$(document).ready(async function() {
	let searchFormWrapperPosition
	let timeoutId

	$('#scrollToTop').click(function() {
		$('html, body').animate({ scrollTop: 0 }, 500)
	})

	console.log('okkk')

	$('.carousel-partenaires').owlCarousel({
		loop: true,
		margin: 30,
		nav: false,
		dots: false,
		autoplay: true,
		autoplayTimeout: 2500,
		responsive: {
			0: {
				items: 2
			},
			768: {
				items: 4
			},
			1024: {
				items: 8
			},
			1440: {
				items: 12
			}
		}
	})

	const offreSlider = $('.offre').owlCarousel({
		loop: true,
		margin: 30,
		nav: false,
		dots: false,
		autoplay: true,
		autoplayTimeout: 6000,
		pauseOnHover: true,
		items: 1
	})

	$('.offre .prev').click(function() {
		offreSlider.trigger('prev.owl.carousel')
	})

	$('.offre .next').click(function() {
		offreSlider.trigger('next.owl.carousel')
	})

	searchFormWrapperPosition = $('#searchFormWrapper').offset()

	$('#searchBiensWrapper').html(generateLoader(50))
	$('#programmesSimilaires .programmesSimilairesContent').html(
		generateLoader(50)
	)

	const isBien = $('#toggleSearchBiens input').prop('checked')

	initializeSearchParams().then(async () => {
		await getSearchResults(1, isBien)
	})

	setTimeout(function() {
		initializeMaxHeightSearchList()
	}, 10)

	$(window).scroll(function() {
		if ($(window).scrollTop() >= $('.mainWrapper').offset().top && $(window).width() < 768 && $(window).scrollTop() < $('.mainWrapper').offset().top + $('.mainWrapper').outerHeight()) {
			$('#mobileBottomTabs').removeClass('hidden')
		} else {
			$('#mobileBottomTabs').addClass('hidden')
		}
		const scrollTop = $('#scrollToTop')
		if ($(window).scrollTop() >= 800) {
			scrollTop.replaceClass('-bottom-full -right-full', 'bottom-[84px] right-4')
		} else {
			// scrollTop.replaceClass("bottom-4 right-4", "-bottom-full -right-full");
			scrollTop.removeClass('bottom-4 right-4')
			scrollTop.addClass('-bottom-full -right-full')
		}
	})

	$('.mobileOpenFormSearchProperty').click(function() {
		if ($('#searchFormWrapper').hasClass('hidden')) {
			$('#searchFormWrapper').removeClass('hidden')
			$('#searchFormWrapper').addClass('open')
			$('body').addClass('overflow-hidden')
			$('#searchPropertyWrapper').append(`
                <div class="z-[1] bg-black bg-opacity-50 h-screen backdrop-blur-sm" id="bakcdropMobileSearchOpen"></div>
      `)
			$('#scrollToTop').css('z-index', '1')
			$('#mobileBottomTabs').css('z-index', '1')
		} else {
			$('#searchFormWrapper').addClass('hidden')
			$('#searchFormWrapper').removeClass('open')
			$('body').removeClass('overflow-hidden')
			$('#bakcdropMobileSearchOpen').remove()
			$('#scrollToTop').css('z-index', '999')
			$('#mobileBottomTabs').css('z-index', '50')
		}
	})

	let initialHeightSearchPropertyWrapper = $('#searchPropertyWrapper').outerHeight() + 40 // 40 = margin top mt-10

	$(window).scroll(function() {
		let top = $('.mainWrapper').offset().top + 60
		const isFixed = $('#searchPropertyWrapper').hasClass('fixed')

		if (isFixed && $(window).width() < 768) {
			top = top - 225
		} else {
			top = top - 60
		}

		if ($(window).scrollTop() >= top) {
			let top = 0

			if ($(window).width() < 1280) {
				$('body').css('padding-top', `${initialHeightSearchPropertyWrapper}px`)
			}

			$('#searchPropertyWrapper').removeClass('mt-10 px-3')

			if ($(window).width() < 768) {
				top = Math.round(Math.min($('#topNav').outerHeight() + $('#topNavMenu').outerHeight()) - 1)
			} else {
				top = 0
				$('#searchPropertyWrapper').removeClass(`lg:mt-20`)
				$('.searchPropertyWrapperToggle').children().removeClass('lg:w-[55%]')
			}

			if (!$('#searchFormWrapper').hasClass('open')) {
				$('#searchFormWrapper').addClass('hidden')
			}

			$('.mobileOpenFormSearchProperty').removeClass('hidden')

			$('.searchPropertyWrapperToggle').addClass('flex items-center gap-2 justify-between')
			$('.searchPropertyWrapperToggle').children().removeClass('mx-auto')
			$('.searchPropertyWrapperToggle').children().addClass('bg-gray-100 w-full p-3 items-center shadow-[0_5px_20px_-2px_rgba(0,0,0,0.3)]')
			$('.searchPropertyWrapperToggle').children().children().addClass('gap-x-2')
			$('.searchPropertyWrapperToggle').children().find('button').each(function() {
				$(this).addClass('px-4 py-[2px]')
				$(this).removeClass('flex-1 py-2 lg:p-4 lg:text-4xl')
				$(this).find('svg').each(function() {
					$(this).removeClass('lg:w-[35px] lg:h-[35px]')
					$(this).on('click', function() {
						$(this).removeClass('lg:w-[35px] lg:h-[35px]')
					})
				})
			})

			$('#searchPropertyWrapper').addClass(`fixed !top-[${top}px] left-0 right-0 z-50`)
		} else {

			$('body').removeClass('overflow-hidden')

			$('body').css('padding-top', `0`)

			$('#searchPropertyWrapper').addClass('mt-10 px-3')
			$('#searchPropertyWrapper').removeClass(`fixed !top-[${top}px] left-0 right-0 z-50`)

			$('.mobileOpenFormSearchProperty').addClass('hidden')
			$('.searchPropertyWrapperToggle').removeClass('flex items-center gap-2 justify-between')
			$('.searchPropertyWrapperToggle').children().addClass('mx-auto')
			$('.searchPropertyWrapperToggle').children().removeClass('bg-gray-100 w-full p-3 items-center shadow-[0_5px_20px_-2px_rgba(0,0,0,0.3)]')
			$('.searchPropertyWrapperToggle').children().children().removeClass('gap-x-2')
			$('.searchPropertyWrapperToggle').children().find('button').each(function() {
				$(this).removeClass('px-4 py-[2px]')
				$(this).addClass('flex-1 py-2 lg:p-4 lg:text-4xl')
				$(this).find('svg').each(function() {
					$(this).addClass('lg:w-[35px] lg:h-[35px]')
					$(this).on('click', function() {
						$(this).addClass('lg:w-[35px] lg:h-[35px]')
					})
				})
			})

			$('#searchFormWrapper').removeClass('hidden')

			if ($('#searchFormWrapper').hasClass('open')) {
				$('#searchFormWrapper').removeClass('open')
			}

			$('#bakcdropMobileSearchOpen').remove()

			$('#searchPropertyWrapper').addClass(`lg:mt-20`)
			$('.searchPropertyWrapperToggle').children().addClass('lg:w-[55%]')
		}
	})

	$(window).resize(function() {
		initializeMaxHeightSearchList()

		const isFixed = $('#searchPropertyWrapper').hasClass('fixed')
		const classList = $('#searchPropertyWrapper').attr('class').split(/\s+/)
		classList.forEach(function(item) {
			if (item.startsWith('top-') || item.startsWith('!top-')) {
				$('#searchPropertyWrapper').removeClass(item)
			}
		})
		if ($(window).width() > 768) {
			$('#searchPropertyWrapper').addClass('top-0')
		} else {
			let top = Math.round(Math.min($('#topNav').outerHeight() + $('#topNavMenu').outerHeight())) - 1
			$('#searchPropertyWrapper').addClass(`!top-[${top}px]`)
		}

		if ($(window).width() < 1280) {
			initialHeightSearchPropertyWrapper = $('#searchPropertyWrapper').outerHeight() + 40 // 40 = margin top mt-10
		}

		// const map = $("#map");
		// const mapClassList = map.attr("class").split(/\s+/);
		// const heightNavFixed = $("#searchPropertyWrapper").outerHeight();

		// if ($(window).width() > 1024) {

		// } else if ($(window).width() > 1280) {
		//   mapClassList.forEach(function (item) {
		//     if (item.startsWith("xl:h-")) {
		//       map.removeClass(item);
		//     }
		//   });
		//   console.log(heightNavFixed);
		//   map.addClass(`xl:h-[calc(100vh_+_${heightNavFixed}px)]`);
		// }
	})

	$(document).on(
		'click',
		'#searchBiensWrapper #loadMoreBiens',
		async function() {
			const isBien = $('#toggleSearchBiens input').prop('checked')
			const nextPage = parseInt($(this).attr('data-next'))
			$(this).text('Chargement...')
			await getSearchResults(nextPage, isBien)
		}
	)

	$(document).on('click touchstart', function (e) {
		if (
			$(e.target).closest('#wrapperLocaliteSearch').length === 0 &&
			$('#villeSearchListWrapper').hasClass('open')
		) {
			$('#villeSearchListWrapper').fadeOut('fast')
			$('#villeSearchListWrapper').removeClass('open')
			$('#villeSearch').val('')
			$('#villeSearch').attr('placeholder', '')
			$('#villeSearchRecap').fadeIn('fast')
			if ($('#villeSearchSuggestions').children().length > 0) {
				$('#villeSearchSuggestions')
					.closest('#villeSearchSuggestionsWrapper')
					.replaceClass('block', 'hidden')
				$('#villeSearchSuggestions').children().remove()
			}
		}
	})

	$(document).on('keyup', function(e) {
		if ($('#villeSearchListWrapper').hasClass('open')) {
			if (e.key === 'Escape') {
				$('#villeSearch').blur()
				$('#villeSearchListWrapper').fadeOut('fast')
			}
		}
	})

	let height = false

	let minHeight =
		$('#searchFormWrapper').offset().top +
		$('#searchFormWrapper').outerHeight() -
		$(window).height() +
		32 // 32 = padding bottom

	if ($('.offreWrapper').length) {
		height = $('.offreWrapper').outerHeight()
	}

	if (height) {
		minHeight = minHeight - height
	}

	$('main').addClass(`xl:mt-[${minHeight}px]`)

	$(window).resize(function() {
		if ($(window).width() > 1270 && $(window).height() > 700) {
			let minHeight =
				$('#searchFormWrapper').offset().top +
				$('#searchFormWrapper').outerHeight() -
				$(window).height() +
				32 // 32 = padding bottom

			if ($('#searchPropertyWrapper').hasClass('fixed')) {
				minHeight = -229
			}

			if ($('.offreWrapper').length) {
				height = $('.offreWrapper').outerHeight()
				minHeight = minHeight - height
			}

			const classList = $('main').attr('class').split(/\s+/)
			classList.forEach(function(item) {
				if (item.startsWith('xl:mt-')) {
					$('main').removeClass(item)
				}
			})
			$('main').addClass(`xl:mt-[${minHeight}px]`)
		} else {
			const classList = $('main').attr('class').split(/\s+/)
			classList.forEach(function(item) {
				if (item.startsWith('xl:mt-')) {
					$('main').removeClass(item)
				}
			})
			$('main').addClass('xl:mt-0')
		}
	})

	let className

	$('#showMap').click(function() {
		$('#map').detach().appendTo('#mapMobileWrapper .map')
		$('#mapMobileWrapper').removeClass('hidden')
		className = $('#map').attr('class').split(/\s+/)
		// clear all classes
		className.forEach(function(item) {
			$('#map').removeClass(item)
		})
		$('#map').addClass('h-full w-full position-initial')
	})

	$('#mapMobileWrapper .map .closeMap').click(function() {
		$('#mapMobileWrapper').addClass('hidden')
		const map = $('#map')
		// clear all classes
		const mapClassList = map.attr('class').split(/\s+/)
		mapClassList.forEach(function(item) {
			map.removeClass(item)
		})
		// add previous classes
		className.forEach(function(item) {
			map.addClass(item)
		})
		$('#map').detach().insertAfter('.test22')
	})

	$('#habiter').click(function() {
		$('#fiscaliteWrapper').replaceClass('flex', 'hidden')
		$('#searchWrapper').replaceClass('xl:grid-cols-5', 'xl:grid-cols-4')
		$('#habiter').addClass('bg-white text-primary')
		$('#habiter').removeClass('bg-primary text-white')
		const isNavFixed = $('#searchPropertyWrapper').hasClass('fixed')
		let responsiveClass = ''
		if (!isNavFixed) {
			responsiveClass = 'lg:w-[35px] lg:h-[35px]'
		}
		if (
			!$('#habiter').find('svg').length > 0 &&
			$('#habiter').hasClass('bg-white')
		) {
			$('#habiter').prepend(`
            <svg xmlns="http://www.w3.org/2000/svg" class="w-[16px] h-[16px] ${responsiveClass}" fill="currentColor"  viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </svg>
        `)
		}
		$('#investir').removeClass('bg-white text-primary')
		$('#investir').addClass('bg-primary text-white')
		$('#investir').find('svg').remove()
		if (isNavFixed && !$('#searchFormWrapper').hasClass('open')) {
			$('.mobileOpenFormSearchProperty').click()
		}
		$('#search').click()
	})

	$('#investir').click(function() {
		$('#investir').addClass('bg-white text-primary')
		$('#fiscaliteWrapper').replaceClass('hidden', 'flex')
		$('#searchWrapper').replaceClass('xl:grid-cols-4', 'xl:grid-cols-5')
		$('#investir').removeClass('bg-primary text-white')
		const isNavFixed = $('#searchPropertyWrapper').hasClass('fixed')
		let responsiveClass = ''
		if (!isNavFixed) {
			responsiveClass = 'lg:w-[35px] lg:h-[35px]'
		}
		if (
			!$('#investir').find('svg').length > 0 &&
			$('#investir').hasClass('bg-white')
		) {
			$('#investir').prepend(`
            <svg xmlns="http://www.w3.org/2000/svg" class="w-[16px] h-[16px] ${responsiveClass}" fill="currentColor"  viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </svg>
        `)
		}
		$('#habiter').removeClass('bg-white text-primary')
		$('#habiter').addClass('bg-primary text-white')
		$('#habiter').find('svg').remove()
		if (isNavFixed && !$('#searchFormWrapper').hasClass('open')) {
			$('.mobileOpenFormSearchProperty').click()
		}
		$('#search').click()
	})

	$('#villeSearch').on('click focus', async function(e) {
		// Si je viens de l'event focus, je ne fais rien
		if (e.type !== 'focus') {
			$('#villeSearch').focus()
		}
		$('#villeSearchRecap').fadeOut('fast')
		$('#villeSearch').attr('placeholder', 'Rechercher une ville, un code postal')
		$('#villeSearchListWrapper').fadeIn('fast')

		const { cps, villes } = await getCurrentSearchList()

		if (cps.length && villes.length) {
			if (!$('#villeSearchListWrapper').hasClass('open')) {
				$('#villeSearchProximite').html(generateLoader())
				getNearestCities(cps, villes)
			}
		} else {
			$('#villeSearchProximite').html(
				`<p class="text-sm">Aucune ville à proximité</p>`
			)
		}

		$('#villeSearchListWrapper').addClass('open')
	})

	$('#villeSearchRecap').on('click', function() {
		$('#villeSearch').click()
	})

	$('#villeSearch').on('input', async function() {
		clearTimeout(timeoutId)

		const ville = $(this).val()
		if (ville.length > 2) {
			$('#villeSearchSuggestions')
				.closest('#villeSearchSuggestionsWrapper')
				.replaceClass('hidden', 'block')
			$('#villeSearchSuggestions').html(generateLoader())

			timeoutId = setTimeout(async () => {
				const { cps, villes } = await getCurrentSearchList()

				$.ajax({
					url: '/api/villes/suggestions',
					type: 'GET',
					data: {
						ville: ville,
						exludeCPs: JSON.stringify(cps),
						exludeVilles: JSON.stringify(villes)
					},
					dataType: 'json',
					success: function(data) {
						if (data.length) {
							const villes = data
								.map(
									(ville) =>
										`<button class="flex items-center gap-1 bg-primary rounded-md px-2 py-1 text-white text-sm addVilleSuggestion">
                            ${ville.ville} - ${ville.cp}
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"  viewBox="0 0 16 16">
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                            </svg>
                            </button>`
								)
								.join('')

							$('#villeSearchSuggestions').html(villes)
						} else {
							$('#villeSearchSuggestions').html(
								'<p class=\'text-sm\'>Aucune ville ne correspond à votre recherche</p>'
							)
						}
					}
				})
			}, 500)
		} else {
			$('#villeSearchSuggestions')
				.closest('#villeSearchSuggestionsWrapper')
				.replaceClass('block', 'hidden')
		}
	})

	$('#toggleSearchBiens input').change(function() {
		const isChecked = $(this).prop('checked')
		$(this).attr('disabled', true) // Enable/disable to prevent multiple requests and disable after request ended on getSearchResults function
		$('#searchBiensWrapper').html(generateLoader(50))
		getSearchResults(1, isChecked)
	})

	$('#Toggle3').change(function() {
		const isChecked = $(this).prop('checked')
		$(this).attr('disabled', true) // Enable/disable to prevent multiple requests and disable after request ended on getSearchResults function
		$('#searchBiensWrapper').html(generateLoader(50))
		getSearchResults(1, isChecked)
		$(this).attr('disabled', false)
	})

	$(document).on('click', '#bakcdropMobileSearchOpen', function() {
		$('.mobileOpenFormSearchProperty').click()
	})

	$('.closeOffer').click(function() {
		const height = $('.offreWrapper').outerHeight()
		const menuLinksClassList = $('#menuLinks').attr('class').split(/\s+/)
		let topStart = 0
		menuLinksClassList.forEach(function(item) {
			if (item.startsWith('top-')) {
				topStart = item.replace('top-[', '').replace('px]', '')
			}
		})
		const menuLinksTopStyle = $('#menuLinks').css('top') ? parseInt($('#menuLinks').css('top').replace('px', '')) : topStart

		$('#menuLinks').css('top', `${menuLinksTopStyle - height}px`)
		$('.offreWrapper').remove()
	})

	$(document).on('click', '#resetSearch', async function() {
		const button = $(this)
		$.ajax({
			url: '/api/resetSearch',
			type: 'GET',
			dataType: 'json',
			success: function(data) {
				window.location.href = window.location.pathname
			}
		})
	})

	$(document).on('click', '.searchCard', function(e) {
		const programmeId = parseInt($(this).attr('data-id'))

		// Trouver le marqueur qui contient ce programmeId
		const marker = window.markers.find((m) => {
			// Support ancien format (programmeId unique) et nouveau format (tableau programmeIds)
			return m.programmeId == programmeId || (m.programmeIds && m.programmeIds.includes(programmeId))
		})

		const searchCardActive = $('.searchCard.active')

		if (searchCardActive.length > 0) {
			searchCardActive.removeClass('active outline outline-2 outline-primary')
		}

		// Si le marqueur a plusieurs programmes, mettre en évidence toutes les cartes
		if (marker && marker.programmeIds && marker.programmeIds.length > 1) {
			marker.programmeIds.forEach((id) => {
				$(`.searchCard[data-id="${id}"]`).addClass('active outline outline-2 outline-primary')
			})
		} else {
			$(this).addClass('active outline outline-2 outline-primary')
		}

		if (window.activeInfoWindow) {
			window.activeInfoWindow.close()
		}

		if (marker && window.mapInstance) {
			window.mapInstance.panTo(marker.position)
			window.mapInstance.setZoom(14)

			// L'infowindow est stockée pour chaque programmeId
			const infowindow = window.infowindowProgrammes[programmeId]

			if (infowindow) {
				infowindow.open({
					anchor: marker,
					shouldFocus: false
				})
				window.activeInfoWindow = infowindow
			}
		}

		$('#map').focus()
	})

	$(document).on('click', '.removeCitySearch', async function(e) {
		clearTimeout(timeoutId)
		e.stopPropagation()
		$(this).remove()

		updateRecapSearch(
			$('#villeSearchList').find('button'),
			$('#villeSearchRecap')
		)

		timeoutId = setTimeout(async () => {
			const { cps, villes } = await getCurrentSearchList()
			getNearestCities(cps, villes)
		}, 500)
	})

	$('#search').click(async function() {
		const isBien = $('#toggleSearchBiens input').prop('checked')
		$('#searchBiensWrapper').html(generateLoader(50))
		await getSearchResults(1, isBien)
	})

	$(document).on('click', '.addNearestCity', async function(e) {
		e.stopPropagation()

		const ville = $(this).text()

		$('#villeSearchList').append(`
            <button class="flex items-center gap-1 bg-primary rounded-md px-2 py-1 text-white text-sm removeCitySearch">
                ${ville}
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"  viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
            </button>
        `)
		updateRecapSearch(
			$('#villeSearchList').find('button'),
			$('#villeSearchRecap')
		)

		const { cps, villes } = await getCurrentSearchList()

		getNearestCities(cps, villes)
	})

	$(document).on('click', '.addVilleSuggestion', async function(e) {
		e.stopPropagation()

		const ville = $(this).text()

		if ($('#villeSearchList').find('button').length > 0) {
			$('#villeSearchList').append(`
            <button class="flex items-center gap-1 bg-primary rounded-md px-2 py-1 text-white text-sm removeCitySearch">
                ${ville}
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"  viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
            </button>
        `)
		} else {
			$('#villeSearchList').html(`
            <button class="flex items-center gap-1 bg-primary rounded-md px-2 py-1 text-white text-sm removeCitySearch">
                ${ville}
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"  viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
            </button>
        `)
		}

		updateRecapSearch(
			$('#villeSearchList').find('button'),
			$('#villeSearchRecap')
		)

		const { cps, villes } = await getCurrentSearchList()

		getNearestCities(cps, villes)

		$('#villeSearch').val('')

		$('#villeSearchSuggestions')
			.closest('#villeSearchSuggestionsWrapper')
			.replaceClass('block', 'hidden')

		$('#villeSearchSuggestions').children().remove()
	})

	$(document).on('click', '.gm-style-iw-a button[title="Fermer"]', function() {
		const searchCardActive = $('.searchCard.active')

		if (searchCardActive.length > 0) {
			searchCardActive.removeClass('active outline outline-2 outline-primary')
		}

		// window.mapInstance.fitBounds(window.bounds, 15);
	})

	async function getCurrentSearchList() {
		let cps = []
		let villes = []

		$('#villeSearchList')
			.find('button')
			.each(function(_, el) {
				const ville = $.trim($(el).text())
				villes.push(ville)

				const cp = $.trim($(el).text()).split(' - ')[1]
				cps.push(cp)
			})

		const form = $('#searchFormWrapper')
		const data = new FormData(form[0])

		const typologies = data.getAll('typologie[]').length ? data.getAll('typologie[]') : null
		const surfaceMin = data.get('surface') ?? 0
		const budgetMin = data.get('budgetMin') ?? 0
		const budgetMax = data.get('budgetMax') ?? 1000000
		const typeHabitation = data.getAll('typeHabitation[]').length ? data.getAll('typeHabitation[]') : null
		const defisc = $('#investir').hasClass('bg-white')
			? data.getAll('defisc[]').length ? data.getAll('defisc[]') : null
			: null
		const currentWidth = $(window).width()

		let order = null
		if (currentWidth >= 768) {
			order = $('#order').find('input:checked').val() ?? 'prix_asc'
		} else {
			order = $('#orderMobile').find('input:checked').val() ?? 'prix_asc'
		}

		const pour = $('#habiter').hasClass('bg-white') ? 'habiter' : 'investir'

		return {
			cps,
			villes,
			typologies,
			surfaceMin,
			budgetMin,
			budgetMax,
			typeHabitation,
			order,
			defisc,
			pour
		}
	}

	async function initializeSearchParams() {
		await $.ajax({
			url: '/api/villes',
			type: 'GET',
			dataType: 'json',
			success: function(data) {
				if (data.length) {
					const html = data
						.map(
							(ville) =>
								`<button class="flex items-center gap-1 bg-primary rounded-md px-2 py-1 text-white text-sm removeCitySearch">
                        ${ville.ville} - ${ville.cp}
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"  viewBox="0 0 16 16">
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </button>`
						)
						.join('')

					$('#villeSearchList').html(html)

					updateRecapSearch(
						$('#villeSearchList').find('button'),
						$('#villeSearchRecap')
					)
				} else {
					$('#villeSearchRecap').html(`<p class='text-xs'>Toute la france</p>`)
					$('#villeSearchList').html(`
                        <span class="flex items-center gap-1 bg-primary rounded-md px-2 py-1 text-white text-sm">
                            Toute la france
                        </span>
                    `)
				}
			}
		})
	}

	function getNearestCities(cps, villes, pour = 'habiter', defisc = null) {
		$('#villeSearchProximite').html(generateLoader())
		if (cps.length && villes.length) {
			$.ajax({
				url: '/api/nearestCity',
				type: 'GET',
				data: {
					CPs: JSON.stringify(cps),
					VILLEs: JSON.stringify(villes),
					pour: pour,
					defisc: defisc
				},
				dataType: 'json',
				success: function(data) {
					if (data.length) {
						const villes = data
							.map(
								(ville) =>
									`<button class="flex items-center gap-1 bg-primary rounded-md px-2 py-1 text-white text-sm addNearestCity">
                            ${ville.ville} - ${ville.cp}
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"  viewBox="0 0 16 16">
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                            </svg>
                            </button>`
							)
							.join('')

						$('#villeSearchProximite').html(villes)
					} else {
						$('#villeSearchProximite').html(
							`<p class="text-sm">Aucune ville à proximité</p>`
						)
					}
				}
			})
		} else {
			$('#villeSearchProximite').html(
				`<p class="text-sm">Aucune ville à proximité</p>`
			)
		}
	}

	function updateRecapSearch(data, el) {
		const ville = data[0]?.textContent.split(' - ')[0]
		const cp = data[0]?.textContent.split(' - ')[1]

		if (ville && cp) {
			let firstVille = ville + ' - ' + cp
			if (data.length > 1) {
				el.html(firstVille + ' et ' + (data.length - 1) + ' de plus')
			} else if (data.length === 1) {
				el.html(firstVille)
			}
		} else {
			el.html('Toute la france')
			$('#villeSearchList').html(`
                <span class="flex items-center gap-1 bg-primary rounded-md px-2 py-1 text-white text-sm">
                    Toute la france
                </span>
            `)
			// clear nearest cities if has children
			if ($('#villeSearchProximite').children().length > 0) {
				$('#villeSearchProximite').children().remove()
				$('#villeSearchProximite').html(
					`<p class="text-sm">Aucune ville à proximité</p>`
				)
			}
		}
	}

	function initializeMaxHeightSearchList() {
		const position =
			$('#villeSearch').offset().top + $('#villeSearch').height() + 50
		$('#villeSearchListWrapper').css(
			'max-height',
			`calc(100vh - ${position}px)`
		)
	}

	function generateLoader(size = 24) {
		return `<svg width = "${size}" height = "${size}" viewBox = "0 0 44 44" xmlns = "http://www.w3.org/2000/svg" stroke = "#514a68" class= "justify-self-start" >
        <g fill="none" fill-rule="evenodd" stroke-width="2">
            <circle cx="22" cy="22" r="1">
                <animate attributeName="r"
                    begin="0s" dur="1.8s"
                    values="1; 20"
                    calcMode="spline"
                    keyTimes="0; 1"
                    keySplines="0.165, 0.84, 0.44, 1"
                    repeatCount="indefinite" />
                <animate attributeName="stroke-opacity"
                    begin="0s" dur="1.8s"
                    values="1; 0"
                    calcMode="spline"
                    keyTimes="0; 1"
                    keySplines="0.3, 0.61, 0.355, 1"
                    repeatCount="indefinite" />
            </circle>
            <circle cx="22" cy="22" r="1">
                <animate attributeName="r"
                    begin="-0.9s" dur="1.8s"
                    values="1; 20"
                    calcMode="spline"
                    keyTimes="0; 1"
                    keySplines="0.165, 0.84, 0.44, 1"
                    repeatCount="indefinite" />
                <animate attributeName="stroke-opacity"
                    begin="-0.9s" dur="1.8s"
                    values="1; 0"
                    calcMode="spline"
                    keyTimes="0; 1"
                    keySplines="0.3, 0.61, 0.355, 1"
                    repeatCount="indefinite" />
            </circle>
        </g>
        </svg> `
	}

	async function getSearchResults(page = 1, isBien = false) {
		const {
			cps,
			villes,
			typologies,
			surfaceMin,
			budgetMin,
			budgetMax,
			typeHabitation,
			order,
			defisc,
			pour
		} = await getCurrentSearchList()

		await $.ajax({
			url: '/api/search',
			type: 'GET',
			data: {
				budgetMin: budgetMin,
				budgetMax: budgetMax,
				typologie: typologies,
				surfaceMin: surfaceMin,
				typeHabitation: typeHabitation,
				villes: villes.length ? villes : false,
				cps: cps.length ? cps : false,
				defisc: defisc,
				pour: pour,
				listBiens: isBien,
				order: order,
				offset: 0,
				p: page
			},
			dataType: 'json',
			success: async function(data) {
				const html = data.html
				if ($('#searchBiensWrapper').children().length > 1) {
					$('#loadMoreWrapper').remove()
					$('#searchBiensWrapper').append(html)
				} else {
					$('#searchBiensWrapper').find('svg').remove()
					$('#searchBiensWrapper').html(html)
				}

				if (data.markers.length > 0) {
					populateMap(data.markers, page)
				} else if (window.mapInstance) {
					window.mapInstance.setCenter({
						lat: 46.494739,
						lng: 2.602833
					})
				}

				$('#toggleSearchBiens input').attr('disabled', false)

				$('.pourRecap').html(pour === 'investir' ? 'investir' : 'habiter')
				$('.isProgrammeRecap').html(isBien ? 'Biens' : 'Programmes')

				if (data.isSameSearch === false) {
					$('#resetSearch').removeClass('hidden')
				}

				if ($('#searchFormWrapper').hasClass('open')) {
					window.scrollTo({
						top: $('.mainWrapper').offset().top - ($(window).width() < 768 ? 145 : 0),
						behavior: 'smooth'
					})
					$('.mobileOpenFormSearchProperty').trigger('click')
				}

				await getProgrammesSimilaires()
			}
		})
	}

	async function getProgrammesSimilaires() {
		const programmesSimilaires = $('#searchBiensWrapper')
			.find('[data-id]')
			.map((_, el) => $(el).data('id'))
			.get()

		const valeursUniques = programmesSimilaires.filter((value, index, self) => {
			return self.indexOf(value) === index
		})

		$.ajax({
			url: '/api/programmesSimilaires',
			type: 'POST',
			data: {
				excludeProgrammesIds:
					programmesSimilaires.length > 0 ? valeursUniques : false
			},
			dataType: 'json',
			success: function(data) {
				const html = data.html
				$('.programmesSimilairesContent').html(html)
			}
		})
	}

	function clearAllMarkers() {
		if (window.markers && window.markers.length > 0) {
			window.markers.forEach((marker) => {
				marker.setMap(null)
			})
			window.markers = [] // Efface le tableau des marqueurs
		}
	}

	function populateMap(markers, page) {
		// Attendre que Google Maps soit chargé
		if (!window.googleMapsLoaded || typeof google === 'undefined' || typeof google.maps === 'undefined') {
			console.log('Waiting for Google Maps to load...')
			setTimeout(() => populateMap(markers, page), 100)
			return
		}

		if (!window.mapInstance) {
			console.warn('Map instance is not initialized. Skipping map population.')
			return
		}

		if (page === 1) {
			const map = window.mapInstance
			let bounds = new google.maps.LatLngBounds()

			clearAllMarkers()

			// Grouper les marqueurs par coordonnées GPS
			const markersByPosition = {}
			markers.forEach((m) => {
				if (m.lat && m.lng) {
					const key = `${m.lat}_${m.lng}`
					if (!markersByPosition[key]) {
						markersByPosition[key] = []
					}
					markersByPosition[key].push(m)
				}
			})

			console.log('Markers grouped by position:', markersByPosition)

			// Créer un marqueur unique par position
			Object.entries(markersByPosition).forEach(([_, programmesAtPosition], index) => {
				const firstProgramme = programmesAtPosition[0]
				const position = new google.maps.LatLng(firstProgramme.lat, firstProgramme.lng)

				// Afficher le nombre de programmes si > 1
				const markerLabel = programmesAtPosition.length > 1 ? {
					text: programmesAtPosition.length.toString(),
					color: '#ffffff',
					fontSize: '12px',
					fontWeight: 'bold'
				} : null

				const marker = new google.maps.Marker({
					position: position,
					map: map,
					title: programmesAtPosition.length > 1
						? `${programmesAtPosition.length} programmes`
						: firstProgramme.programmeName,
					icon: {
						url: firstProgramme.reverse
							? '/assets/images/loc.png'
							: '/assets/images/locReverse.png',
						scaledSize: new google.maps.Size(30, 35),
						zIndex: firstProgramme.reverse
							? google.maps.Marker.MAX_ZINDEX + index
							: google.maps.Marker.MAX_ZINDEX - index
					},
					label: markerLabel
				})

				// Générer l'InfoWindow pour tous les programmes à cette position
				const infowindow = generateInfoWindowMarker(programmesAtPosition)

				marker.addListener('click', () => {
					const searchCardActive = $('.searchCard.active')

					if (searchCardActive.length > 0) {
						searchCardActive.removeClass('active outline outline-2 outline-primary')
					}

					// Mettre en évidence toutes les cartes des programmes à cette position
					programmesAtPosition.forEach((prog) => {
						const searchCard = $(`.searchCard[data-id="${prog.programmeId}"]`)
						searchCard.addClass('active outline outline-2 outline-primary')
					})

					if (window.activeInfoWindow) {
						window.activeInfoWindow.close()
					}

					infowindow.open(map, marker)
					window.activeInfoWindow = infowindow
					map.panTo(position)
					map.setZoom(14)

					// Scroller vers le premier programme
					if ($(`[data-id="${firstProgramme.programmeId}"]`).length > 0) {
						window.scrollTo({
							top: $(`[data-id="${firstProgramme.programmeId}"]`).offset().top - 20,
							behavior: 'smooth'
						})
					}
				})

				if (firstProgramme.reverse) {
					window.reverseMarkers.push(marker)
					bounds.extend(position)
				}

				// Stocker tous les IDs de programmes pour ce marqueur
				marker.programmeIds = programmesAtPosition.map(p => p.programmeId)

				// Stocker l'infowindow pour chaque programme
				programmesAtPosition.forEach((prog) => {
					window.infowindowProgrammes[prog.programmeId] = infowindow
				})

				window.markers.push(marker)
				marker.setMap(map)
			})

			map.fitBounds(bounds, 15)

			if (markers.length < 5) {
				google.maps.event.addListenerOnce(map, 'bounds_changed', function(event) {
					if (this.getZoom()) {
						this.setZoom(15)
					}
				})
			}

			window.bounds = bounds
		}
	}

	function generateInfoWindowMarker(programmes) {
		// Si c'est un seul programme (pour compatibilité)
		if (!Array.isArray(programmes)) {
			programmes = [programmes]
		}

		let contentString = ''

		if (programmes.length > 1) {
			// Plusieurs programmes : afficher une liste
			contentString = `<div class="flex flex-col gap-3 p-2 max-h-[400px] overflow-y-auto">
				<h3 class="font-bold text-primary text-lg sticky top-0 bg-white pb-2">${programmes.length} programmes à cette adresse</h3>`

			programmes.forEach((m) => {
				contentString += `
				<div class="border-b pb-3 last:border-b-0">
					<div class="flex items-start gap-3">
						<div class="flex-shrink-0 rounded-md relative overflow-hidden w-[80px] h-[80px]">
							<img src="https://doc.polyvalence-immobilier.fr/fichiers/files/small/${m.images}" class="w-full h-full object-cover ${m.blur ? 'blur-md' : ''}" />
						</div>
						<div class="flex flex-col gap-1 flex-1">
							<h4 class="text-sm font-bold">
								<span class="${m.blur ? 'blur-sm' : ''}">${m.programmeName}</span>
								<span class="text-xs text-gray-400">(${m.ville})</span>
							</h4>
							<p class="text-xs text-gray-600">${m.adresse}</p>
							<p class="text-xs">Livraison ${m.livraison}</p>
							<p class="text-xs text-primary font-medium">${m.remainingTypo}</p>
							<p class="font-bold text-primary text-sm">À partir de ${formatPrice(m.firstPrice)}</p>
							<div class="flex gap-2 mt-1">
								<a href="${m.programmeLink}" class="text-xs text-primary underline">Voir</a>
								<a href="${m.programmeLink}#lotDisponible" class="text-xs text-primary underline">Biens</a>
							</div>
						</div>
					</div>
				</div>`
			})

			contentString += `</div>`
		} else {
			// Un seul programme : affichage normal
			const m = programmes[0]
			contentString = `<div class="sm:flex items-start xl:items-center gap-x-4 p-2">
				<div class="xl:self-stretch rounded-md relative overflow-hidden">
					<img src="https://doc.polyvalence-immobilier.fr/fichiers/files/small/${m.images}" class="xl:h-full h-[100px] w-full sm:w-[100px] object-cover ${m.blur ? 'blur-md' : ''}" />
				</div>
				<div class="flex flex-col gap-2 max-sm:mt-2">
					<h2 class="text-sm sm:text-lg font-bold overflow-hidden"> <span class="${m.blur ? 'blur-sm' : ''}">${m.programmeName}</span> <span class="text-sm text-gray-400">(${m.ville})</span>
						<p class="text-xs font-medium">${m.adresse}</p>
					</h2>
					<div class="flex flex-col gap-1">
						<p class="text-md">Livraison prévue ${m.livraison}</p>
					</div>
					<div class="flex flex-col gap-1">
						<span class="text-xs text-primary font-medium">${m.remainingTypo}</span>
						<p class="font-bold text-primary text-sm xl:text-lg">
							À partir de ${formatPrice(m.firstPrice)}
						</p>
					</div>
					<div class="flex flex-wrap tems-center justify-between gap-2 xl:gap-5">
						<a href="${m.programmeLink}" class="block text-sm text-primary underline">Voir le programme</a>
						<a href="${m.programmeLink}#lotDisponible" class="block text-sm text-primary underline">Découvrir les biens</a>
					</div>
				</div>
			</div>`
		}

		const infowindow = new google.maps.InfoWindow({
			content: contentString,
			shouldFocus: false,
			maxWidth: programmes.length > 1 ? 450 : 400
		})

		// Personnaliser le bouton de fermeture après ouverture
		google.maps.event.addListener(infowindow, 'domready', function() {
			// Cibler le conteneur du bouton de fermeture
			const closeButtonContainer = document.querySelector('.gm-style-iw-chr')
			if (closeButtonContainer) {
				closeButtonContainer.style.cssText = `
					position: absolute !important;
					top: 8px !important;
					right: 8px !important;
					z-index: 9999 !important;
				`
			}

			// Cibler le bouton de fermeture
			const closeButton = document.querySelector('.gm-style-iw-chr button')
			if (closeButton) {
				// Supprimer les images SVG natives
				closeButton.innerHTML = ''

				// Ajouter notre propre icône X
				closeButton.innerHTML = `
					<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16" style="pointer-events: none;">
						<path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
					</svg>
				`

				// Ajouter des classes/styles personnalisés
				closeButton.style.cssText = `
					width: 26px !important;
					height: 26px !important;
					background: #514a68 !important;
					border: none !important;
					border-radius: 50% !important;
					opacity: 1 !important;
					box-shadow: 0 2px 6px rgba(0,0,0,0.3) !important;
					display: flex !important;
					align-items: center !important;
					justify-content: center !important;
					transition: all 0.3s ease !important;
					cursor: pointer !important;
					color: white !important;
					padding: 0 !important;
					margin: 0 !important;
				`

				// Effet hover
				closeButton.addEventListener('mouseenter', function() {
					this.style.background = '#6d6485 !important'
					this.style.transform = 'scale(1.1) !important'
				})
				closeButton.addEventListener('mouseleave', function() {
					this.style.background = '#514a68 !important'
					this.style.transform = 'scale(1) !important'
				})

				// Ajouter la classe pour afficher le bouton après personnalisation
				closeButtonContainer.classList.add('custom-close')
			}

			// Supprimer le padding du container pour mieux contrôler l'espacement
			const iwContainer = document.querySelector('.gm-style-iw-d')
			if (iwContainer) {
				iwContainer.style.overflow = 'visible !important'
			}
		})

		return infowindow
	}
})
